import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from 'react';
import {
  DEFAULT_SKIN,
  applySkin,
  readBootSkin,
} from './skin';

const SkinContext = createContext({
  skin: DEFAULT_SKIN,
  setSkin: () => {},
});

function getBootSources() {
  if (typeof document === 'undefined') {
    return { document: undefined, storage: undefined };
  }
  return { document, storage: window.localStorage };
}

export function SkinProvider({ children }) {
  const [skin, setSkinState] = useState(() => {
    const sources = getBootSources();
    return applySkin(readBootSkin(sources), sources);
  });

  const setSkin = useCallback((nextSkin) => {
    const next = applySkin(nextSkin, getBootSources());
    setSkinState(next);
    return next;
  }, []);

  const value = useMemo(() => ({ skin, setSkin }), [skin, setSkin]);

  return (
    <SkinContext.Provider value={value}>
      {children}
    </SkinContext.Provider>
  );
}

export function useSkin() {
  return useContext(SkinContext);
}
